export default {
    ABDOMEN: 1,
    ANTEBRACO: 2,
    BOCA: 3,
    CABECA: 4,
    COLUNA: 5,
    COSTAS: 6,
    COTOVELO: 7,
    COXA: 8,
    DEDOS_DA_MAO: 9,
    DEDO_DO_PE: 10,
    FACE: 11,
    JOELHO: 12,
    MAO: 13,
    NARIZ: 14,
    OLHO: 15,
    OMBRO: 16,
    ORELHA: 17,
    PERNA: 18,
    PESCOCO: 19,
    PUNHO: 20,
    PE: 21,
    QUADRIL: 22,
    QUEIXO: 23,
    SUPERCILIOS: 24,
    TESTA: 25,
    TORAX: 26,
    TORNOZELO: 27,
    OUTROS: 28,
}